<template>
<div class='pop-wrap' v-if='rotateStatus' @click='closePop($event)'>
  <div class="rotate-box">
    <i class='close' @click='closePop'></i>
    <div class="top1-time">
      <div class="time-left">
        <span>本轮活动剩余时间：</span>
        <p class="fw"><span v-for="(item,i) in timerobj.hh" :key="i">{{item}}</span></p>
        <p><span v-for="(item,i) in timerobj.mm" :key="i">{{item}}</span></p>
        <p><span v-for="(item,i) in timerobj.ss" :key="i">{{item}}</span></p>
      </div>
      <div class="time-right">
        <span>本轮剩余抽奖次数：</span>
        <p><span v-for="(item,i) in num" :key="i">{{item}}</span></p>
      </div>
    </div>
    <!-- 本期大奖 -->
    <div class="big-prize">
      <div class="img-left" v-show="prize">
        <img :src="`//mnweb.mini1.cn/game/icons/icon${prize.id}.png`" :alt="prize.name">
        <span>{{prize.name}}</span>
      </div>
      <div class="times-lottery">
        <p>我的超级大奖概率：</p>
        <p><span>{{percent}}</span> %</p>
        <p>本轮抽奖参与次数：</p>
        <p><span>{{mynum}}</span></p>
      </div>
    </div>
    <!-- 六宫格抽奖 -->
    <div class="rotate-wrap">
      <div class="rotateL">
        <ul v-show="arrData.length > 0">
          <li v-for="(item,i) in arrData" :key="i" :class="onName === i ? 'on' : ''">
            <img :src="`//mnweb.mini1.cn/game/icons/icon${item.id}.png`" :alt="item.name">
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      <div class="btnr">
        <section class="one">
          <a href="javascript:;" @click="doLottery(1)"></a>
          <p>冒险勋章：<span>50</span></p>
        </section>
        <section class="ten">
          <a href="javascript:;" @click="doLottery(10)"></a>
          <p>冒险勋章：<span>450</span></p>
        </section>
      </div>
    </div>
    <!-- 上期大奖得主 -->
    <div class="prve-big" v-if="last_prize">
      <div v-if="last_prize.user" class="left-big">
        <img :src="last_prize.user.image" alt="" width="60" height="60">
        <p style="margin-top: 10px;">上一期大奖得主：</p>
        <p>{{last_prize.user.uin | hideFn}}</p>
      </div>
      <img v-if="last_prize.award" class="right-img" :src="`//mnweb.mini1.cn/game/icons/icon${last_prize.award.id}.png`" :alt="last_prize.award.name">
    </div>
      <!-- 弹窗 -->
      <div class="prize_pop" v-if="itemflag">
        <h3>奖品</h3>
        <p>恭喜你获得{{item11.name}}*{{item11.num}}</p>
        <a href="javascript:;" @click.stop="closeSure11" class="btn11_sure"></a>
      </div>
      <!-- 弹窗2 -->
      <div class="prize_pop2" v-if="itemflag2">
        <h3>奖品</h3>
        <p v-for="(item,i) in item22" :key="i">恭喜你获得{{item.name}}*{{item.num}}</p>
        <a href="javascript:;" @click.stop="closeSure22" class="btn11_sure"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rotateStatus: Boolean,
    paramsObj: Object
  },
  data() {
    return {
      time: 0,
      timer: null,
      timerobj: {
        hh: "00",
        mm: "00",
        ss: "00"
      },
      num: "999",
      mynum: 0,
      percent: 0,
      last_prize: {
        award: {
          id: 1000,
          name: "迷你豆"
        },
        user: {
          nickname: "我了个去去去去去去去",
          uin: 204615380
        }
      }, // 上期大奖得主
      prize: {
        id: "placeholder",
        name: "暂无数据"
      },
      arrData: [],
      onName: "",
      dotimer: null,
      order: [0, 1, 2, 5, 4, 3],
      onum: "",
      flag: false, // 默认没点击
      item11: {},
      itemflag: false, // 一个奖品
      itemflag2: false,
      item22: []
    }
  },
  watch: {
    rotateStatus(val) {
      if (val) {
        if (this.paramsObj) {
          this.queryInfo();
          this.querySix();
        }
      } else {
        clearInterval(this.timer);
        clearInterval(this.dotimer);
        this.timer = null;
        this.dotimer = null;
        this.onName = "";
        this.onum = "";
        this.flag = false; // 还原
        this.itemflag = false;
        this.itemflag2 = false;
      }
    }
  },
  filters: {
    hideFn(val) {
      // 204 8709 07
      val = val.toString();
      let hideStr = val.substr(3, 4);
      return val.replace(hideStr, "****");
    }
  },
  methods: {
    closeSure22() {
      this.itemflag2 = false;
      this.queryInfo(); // 查询一遍
      this.onName = "";
      this.$emit("queryXun", true)
    },
    closeSure11() {
      this.itemflag = false;
      this.queryInfo(); // 查询一遍
      this.$emit("queryXun", true)
    },
    doLottery(val) {
      if (!this.flag) {
        this.paramsObj.num = val;
        this.$http.post("https://activity.mini1.cn/api/cmcc/joinLottery", this.$qs.stringify(this.paramsObj)).then(rel => {
          console.log(rel)
          if (rel.data.code == 2) {
            this.$message.error('勋章不足');
            this.flag = false; // 还原
            return false
          } else if (rel.data.code == 200) {
            let item = rel.data.data.awards[0];
            let itemarr = rel.data.data.awards; // 数组
            let b = this.arrData.filter((val, i) => {
              return val.id == item.id
            })
            let index = this.arrData.findIndex((value, i) => {
              return value.id == b[0].id;
            })
            this.onum = index;
            if (!this.onName) {
              this.onName = 0;
            }
            let circle = 0; // 圈数 转 10圈吧
            this.dotimer = setInterval(() => {
              this.onName++;
              if (this.onName > 5) {
                this.onName = 0;
                circle++;
              }
              if (circle > 5) {
                if (this.onName == this.onum) {
                  clearInterval(this.dotimer);
                  this.flag = false; // 还原
                  if (this.paramsObj.num == 1) {
                    this.item11 = item;
                    this.itemflag = true;
                    // this.$confirm(`恭喜你获得${item.name}*${item.num}`, '提示', {
                    //   confirmButtonText: '确定',
                    //   showCancelButton: false,
                    //   type: 'success',
                    //   callback: action => {
                    //     this.queryInfo(); // 查询一遍
                    //     this.$emit("queryXun", true)
                    //   }
                    // })
                  } else if (this.paramsObj.num == 10) {
                    this.itemflag2 = true;
                    this.item22 = itemarr;
                    // const h = this.$createElement;
                    // let newDatas = [];
                    // itemarr.forEach(val => {
                    //   newDatas.push(h('p', {
                    //     style: 'fontSize: 18px;margin: 10px;'
                    //   }, `恭喜你获得${val.name}*${val.num}`));
                    // });
                    // this.$msgbox({
                    //   title: '奖品',
                    //   center: true,
                    //   dangerouslyUseHTMLString: true,
                    //   message: h('div', null, newDatas),
                    //   confirmButtonText: '确定',
                    //   showCancelButton: false,
                    //   callback: action => {
                    //     this.queryInfo(); // 查询一遍
                    //     this.onName = "";
                    //     this.$emit("queryXun", true)
                    //   }
                    // })
                  }

                }
              }
            }, 70)
          } else if (rel.data.code == 4) {
            this.$message.error('本轮剩余抽奖次数不足!');
            this.flag = false; // 还原
          } else {
            this.$message.error('服务错误！');
            this.flag = false; // 还原
          }
        })
      } else {
        this.$message.error('抽奖中...');
      }
      this.flag = true;
    },
    closePop(e) {
      if (e.target.className == 'close') {
        this.closePop2()
      } else {
        e.cancelBubble = true
        return false
      }
    },
    closePop2() {
      this.$emit('closeRotate', false)
    },
    clock() {
      let nowTime = new Date(); // 一定是要获取最新的时间
      let second = parseInt((this.time - nowTime.getTime()) / 1000);
      // 用将来的时间毫秒 -  现在的毫秒  / 1000 得到的 还剩下的秒  可能处不断 取整
      // console.log(second);
      // 一小时 3600 秒
      // second / 3600  一共的小时数  /24   天数
      // let h = parseInt(second / 3600 ); //小时
      //console.log(d);
      let h = parseInt(second / 3600 % 24) // 小时
      // console.log(h);
      let m = parseInt(second / 60 % 60); //分钟
      //console.log(m);
      let s = parseInt(second % 60); // 当前的秒
      // console.log(s);
      /* if(d<10)
       {
           d = "0" + d;
       }*/
      // d < 10 ? d = "0" + d : d;
      h < 10 ? h = "0" + h : h;
      m < 10 ? m = "0" + m : m;
      s < 10 ? s = "0" + s : s;
      this.timerobj.hh = h.toString();
      this.timerobj.mm = m.toString();
      this.timerobj.ss = s.toString();
      // console.log("时间还剩: "  + h + "小时 " + m + "分钟 ")
    },
    // 查询抽奖的所有信息
    queryInfo() {
      this.$http.get("https://activity.mini1.cn/api/cmcc/queryUserInfo", {
        params: this.paramsObj
      }).then(rel => {
        if (rel.data.code == 200) {
          let {
            next_prize_time,
            remain_num,
            num,
            percent,
            prize,
            last_prize
          } = rel.data.data;
          this.mynum = num;
          this.prize = prize;
          this.last_prize = last_prize;
          this.percent = (percent * 100).toFixed(3);
          if (remain_num < 100 && remain_num > 9) {
            remain_num = "0" + remain_num
          } else if (remain_num < 10 && remain_num > 0) {
            remain_num = "00" + remain_num
          } else if (remain_num <= 0) {
            remain_num = "000";
          }
          this.num = remain_num.toString();
          this.time = next_prize_time * 1000;
          this.timer = this.clock();
          this.timer = setInterval(this.clock, 1000); // 开启定时器
        }
      })
    },
    // 查询本期抽奖的6个东西
    querySix() {
      this.$http.get("https://activity.mini1.cn/api/cmcc/getGiftList", {
        params: this.paramsObj
      }).then(rel => {
        if (rel.data.code == 200) {
          this.arrData = rel.data.data;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pop-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
}

.prize_pop {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 720px;
  height: 320px;
  margin-left: -360px;
  margin-top: -160px;
  background: url("../assets/images/popprize1.png") no-repeat center;

  p {
    height: 150px;
    line-height: 100px;
    text-align: center;
    font-size: 24px;
    color: #824f20;
  }

  h3 {
    padding-top: 30px;
    font-size: 32px;
    color: #6f4027;
    font-weight: bold;
    text-align: center;
  }

  .btn11_sure {
    position: absolute;
    bottom: 50px;
    left: 50%;
    width: 194px;
    height: 75px;
    margin-left: -97px;
    background: url("../assets/images/btn_sure.png") no-repeat center;
  }
}
.prize_pop2 {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 720px;
  height: 622px;
  margin-left: -360px;
  margin-top: -311px;
  background: url("../assets/images/popprize.png") no-repeat center;

  p {
    line-height: 42px;
    text-align: center;
    font-size: 24px;
    color: #824f20;
  }

  h3 {
    padding-top: 30px;
    font-size: 32px;
    color: #6f4027;
    font-weight: bold;
    text-align: center;
  }

  .btn11_sure {
    position: absolute;
    bottom: 40px;
    left: 50%;
    width: 194px;
    height: 75px;
    margin-left: -97px;
    background: url("../assets/images/btn_sure.png") no-repeat center;
  }
}

.rotate-box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 800px;
  height: 850px;
  margin-left: -400px;
  margin-top: -425px;
  background: url("../assets/images/rotate.png") no-repeat center;

  .close {
    position: absolute;
    right: -62px;
    top: -31px;
    width: 60px;
    height: 60px;
    background: url("../assets/images/close2.png") no-repeat center;
    cursor: pointer;
    transition: all ease 0.3s;
    transform: rotate(0deg);

    &:hover {
      transform: rotate(360deg);
    }
  }

  .top1-time {
    width: 780px;
    margin: 36px auto;
    color: #6f4027;
    height: 45px;

    .time-left {
      float: left;
      width: 468px;
      display: flex;
      justify-content: space-around;

      .fw {
        position: relative;
        margin-left: -10px;

        &::after {
          position: absolute;
          content: "：";
          font-size: 49px;
          font-weight: bold;
          right: -33px;
          top: -5px;
        }

        &::before {
          position: absolute;
          content: "：";
          font-size: 49px;
          font-weight: bold;
          right: -139px;
          top: -5px;
        }
      }

      p {
        display: flex;
        width: 90px;
        margin-top: -14px;
        justify-content: space-between;
        font-size: 49px;
        font-weight: bold;
        line-height: 60px;

        span {
          display: inline-block;
          width: 42px;
          height: 60px;
          text-align: center;
          font-size: 49px;
          font-weight: bold;
          line-height: 60px;
          background: url("../assets/images/timebg.png") no-repeat;
        }
      }
    }

    .time-right {
      float: right;
      width: 300px;
      display: flex;
      justify-content: space-around;
      margin-right: 10px;

      p {
        display: flex;
        width: 140px;
        margin-top: -14px;
        justify-content: space-between;
        font-size: 49px;
        font-weight: bold;
        line-height: 60px;

        span {
          display: inline-block;
          width: 42px;
          height: 60px;
          text-align: center;
          font-size: 49px;
          font-weight: bold;
          line-height: 60px;
          background: url("../assets/images/timebg.png") no-repeat;
        }
      }
    }
  }

  .big-prize {
    display: flex;
    justify-content: space-around;
    width: 500px;
    height: 130px;
    margin: auto;

    .img-left {
      flex: 2;
      line-height: 130px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      span {
        width: 142px;
        text-align: center;
        color: #532b08;
        font-size: 18px;
        line-height: 1.75;
      }

      img {
        width: 66px;
        height: 66px;
        vertical-align: middle;
        margin-left: 74px;
        margin-right: 29px;
      }
    }

    .times-lottery {
      padding-left: 20px;
      padding-top: 12px;
      color: #6f4027;

      span {
        color: #db7d4c;
        font-size: 18px;
      }
    }
  }

  .rotate-wrap {
    width: 500px;
    height: 240px;
    margin: 70px auto 35px;

    .rotateL {
      ul {
        overflow: hidden;
        width: 350px;
        float: left;
        margin-left: 8px;
      }

      li {
        float: left;
        border: 2px solid rgb(210, 172, 133);
        border-radius: 8px;
        background-color: rgb(255, 250, 237);
        width: 105px;
        height: 110px;
        margin: 3px;

        &.on {
          border-color: #ff8468;
          background-color: #ff8468;
        }

        img {
          display: block;
          width: 54px;
          margin: 10px auto 2px;
          height: 54px;
          background: #413324;
          border-radius: 5px;
          padding: 10px;
        }

        span {
          display: block;
          text-align: center;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }

    .btnr {
      float: right;
      width: 140px;
      padding-top: 20px;

      .one,
      .ten {
        margin: 20px 0;

        p {
          text-align: center;
          line-height: 1.75;
          width: 110px;
          margin-top: 5px;

          span {
            color: #c76b3b;
          }
        }

        a {
          display: block;
          width: 120px;
          height: 45px;
        }
      }

      .one {
        a {
          background: url("../assets/images/one_btn.png") no-repeat center;
        }
      }

      .ten {
        a {
          background: url("../assets/images/ten_btn.png") no-repeat center;
        }
      }
    }
  }

  .prve-big {
    width: 360px;
    height: 80px;
    margin: auto;
    color: #6f4027;
    font-weight: bold;

    .left-big {
      float: left;
      width: 80%;
      img {
        width: 60px;
        height: 60px;
        float: left;
        margin-top: 5px;
        margin-right: 8px;
      }
      p {
        margin-top: 6px;
      }
      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    img.right-img {
      float: right;
      width: 64px;
      height: 64px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Rotate.vue